import type { ReactNode } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'

/**
 * The page frame every fuguelab.com route sits inside: skip link, sticky
 * header, `#main-content` landmark, footer.
 *
 * `breadcrumbs` and `children` are slots rather than baked in, because the two
 * builds legitimately differ inside the frame — studio wraps its outlet in a
 * `motion` page transition, and the hymnal deliberately does not (it is
 * prerendered per route, and `PageTransition` decides its animation from
 * `window.matchMedia` DURING RENDER, which the prerenderer cannot evaluate; the
 * server tree and the first client tree would disagree for any visitor with
 * reduced-motion set). Everything outside the slots is byte-identical.
 */
export function ChromeShell({ breadcrumbs, children }: { breadcrumbs?: ReactNode; children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded focus:bg-white focus:px-4 focus:py-2 focus:text-black focus:shadow"
      >
        Skip to content
      </a>
      <Header />
      <main id="main-content" className="flex-grow">
        {breadcrumbs && <div className="container mx-auto px-4 pt-4">{breadcrumbs}</div>}
        {children}
      </main>
      <Footer />
    </div>
  )
}
